import { MinMaxRange } from './min-max-range';
import { VolumeUnits } from './types/volume-units.type';
import { WeightUnits } from './types/weight-units.type';

export class TotalSKUSizeRange extends MinMaxRange {
    constructor(
        public isSelected: boolean,
        public measureOptions?: VolumeUnits | WeightUnits | null,
        public min?: number | null,
        public max?: number | null
    ) {
        super(min, max);
    }
}
